import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/sectors", label: "Sectors" },
  { to: "/experience", label: "Experience" },
  { to: "/contact", label: "Contact" },
];

const WHATSAPP = "https://wa.me/447774924524";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-brand-line bg-white">
      <div className="wrap grid gap-10 py-12 sm:grid-cols-2 md:py-14 lg:grid-cols-[1.4fr_1fr_1.2fr_1fr] lg:gap-12">
        <div className="sm:col-span-2 lg:col-span-1">
          <Link to="/" data-testid="footer-logo-link" aria-label="SafetySymbiosis home">
            <img
              src="/safetysymbiosis-logo.png"
              alt="SafetySymbiosis"
              className="h-24 w-auto"
              width={1640}
              height={959}
              loading="lazy"
            />
          </Link>
          <p className="mt-5 text-sm font-bold uppercase tracking-[0.22em] text-brand-navy sm:text-base">
            Environment <span className="text-brand-green">|</span> Health{" "}
            <span className="text-brand-green">|</span> Safety
          </p>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-brand-charcoal/80">
            Practical HSE &amp; SHEQ consultancy for complex projects and
            high-risk environments.
          </p>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-brand-navy">
            Navigation
          </h3>
          <ul className="mt-4 space-y-2.5">
            {NAV.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-sm text-brand-charcoal transition-colors hover:text-brand-green"
                  data-testid={`footer-nav-${l.label.toLowerCase()}`}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-brand-navy">
            Contact
          </h3>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <a
                href="mailto:enquiries@safetysymbiosis.com"
                className="inline-flex items-start gap-2 text-brand-charcoal transition-colors hover:text-brand-green"
                data-testid="footer-email-enquiries"
              >
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-brand-green" />
                enquiries@safetysymbiosis.com
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-brand-navy">
            Locations
          </h3>
          <ul className="mt-4 space-y-3 text-sm text-brand-charcoal">
            <li className="flex items-start gap-2">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-green" />
              <span>
                United Kingdom
                <span className="block text-xs text-brand-charcoal/70">
                  Manchester — principal operating market
                </span>
              </span>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-green" />
              <span>Supporting clients and projects across Sweden</span>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-green" />
              <span>Supporting clients and projects across Portugal</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-brand-line">
        <div className="wrap flex flex-col items-start justify-between gap-4 pb-20 pt-6 text-xs text-brand-charcoal/70 md:flex-row md:items-center md:pb-6">
          <div>
            <p>
              © {year} SafetySymbiosis. All rights reserved.
            </p>
            <p className="mt-2 flex flex-col gap-1 text-[11px] leading-relaxed md:flex-row md:flex-wrap md:items-baseline md:gap-x-2.5">
              <span>Safety Symbiosis Ltd</span>
              <span className="hidden md:inline" aria-hidden="true">
                ·
              </span>
              <span>Company No. 15885104 (England &amp; Wales)</span>
              <span className="hidden md:inline" aria-hidden="true">
                ·
              </span>
              <span>
                Registered office: 76 Fenlake Road, Bedford, Bedfordshire, MK42
                0ET, United Kingdom
              </span>
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <Link to="/privacy" className="transition-colors hover:text-brand-green" data-testid="footer-legal-privacy">
              Privacy Policy
            </Link>
            <Link to="/cookies" className="transition-colors hover:text-brand-green" data-testid="footer-legal-cookies">
              Cookie Policy
            </Link>
            <Link to="/terms" className="transition-colors hover:text-brand-green" data-testid="footer-legal-terms">
              Terms &amp; Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
